import { injectGlobal } from 'react-emotion'
import { normalize } from 'polished'
import { regularFontFamily, heavyFontFamily, mediumMediaQuery } from 'utils/style-helpers'

injectGlobal`
  ${normalize()}

  * {
    box-sizing: border-box;
  }

  body {
    ${regularFontFamily()}
  }

  h1, h2, h3, h4, h5, h6 {
    ${heavyFontFamily()}
    margin: 0;
  }

  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
  }

  input,
  select {
    -webkit-appearance: none;
    border-radius: 0;
  }

  .Body--dialogOpen {
    overflow: hidden;
  }

  .Body--inlineModalOpen {
    overflow: hidden;

    ${mediumMediaQuery} {
      overflow: visible;
    }
  }
`



// WEBPACK FOOTER //
// ./src/base-style.js